import { AppEntityManager } from './classes/entities/AppEntityManager';
export const testingHelper = {
  entityManager: null as AppEntityManager | null
};
(window as any).testingHelper = testingHelper;